import { Text } from 'rebass/styled-components'
import styled from 'styled-components'

export default styled(Text)`
  &,
  span {
    font-style: normal;
    color: ${(props) => props.theme.colors.primary1};
    margin-top: ${(props) => props.theme.space[2]}px;
    margin-bottom: ${(props) => props.theme.space[1]}px;
    font-family: ${(props) => props.theme.fonts.sans};
    text-transform: uppercase;
    font-weight: ${(props) => props.theme.fontWeights[0]};
    font-size: 0.8rem;
    opacity: 0.8;
  }
`
